export default [
  { label: 'Licencia Médica', value: 'absenceLicense' },
  { label: 'Ausencia Sin Justificar', value: 'unjustifiedAbsence' },
  { label: 'Vacaciones Legales + Proporcionales', value: 'legalHoliday' },
  { label: 'Vacaciones Progresivas', value: 'progressiveHoliday' },
  { label: 'Vacaciones Adicionales', value: 'additionalDays' },
  { label: 'Días Administrativos', value: 'administrativeDays' },
  { label: 'Permiso Con Goce de Sueldo', value: 'permissionPaidLeave' },
  { label: 'Permiso Sin Goce de Sueldo', value: 'permissionWithoutPaidLeave' }
];